// @flow
import { handleActions } from 'redux-actions';
import { POP_BREADCRUMB, PUSH_BREADCRUMB, PUSH_MULTIPLE_BREADCRUMBS } from './constants';


export type Breadcrumb = {
    +title: string,
    +link?: string,
};

export type State = Array<Breadcrumb>;

const initialState: State = [];

const reducer = handleActions({
    [PUSH_BREADCRUMB]: (state: State, { payload }: {
        payload: {
            title: string,
            link?: string,
        }
    }) => {
        const { title, link } = payload;

        let newBreadcrumbs = [];
        const bIndex = state.findIndex((b) => b.title === title);
        if (bIndex !== -1) {
            newBreadcrumbs = state.slice(0, bIndex + 1);
        } else {
            newBreadcrumbs = state.slice(0);
            newBreadcrumbs.push({
                title, link,
            });
        }

        return [
            ...newBreadcrumbs,
        ];
    },
    [PUSH_MULTIPLE_BREADCRUMBS]: (state: State, { payload }: {
        payload: {
            breadcrumbs: Array<Breadcrumb>,
        }
    }) => {
        const { breadcrumbs } = payload;
        const firstBreadcrumb = breadcrumbs[0];

        let newBreadcrumbs = [];
        const bIndex = state.findIndex((b) => b.title === firstBreadcrumb.title);
        if (bIndex !== -1) {
            newBreadcrumbs = state.slice(0, bIndex);
        } else {
            newBreadcrumbs = state.slice(0);
        }

        return [
            ...newBreadcrumbs, ...breadcrumbs,
        ];
    },
    [POP_BREADCRUMB]: (state: State, { payload }: {
        payload: {
            title: string,
            offset: number
        },
    }) => {
        const { title } = payload;

        const endIndex = state.findIndex((b) => b.title === title);
        if (endIndex !== -1) {
            return [
                ...state.slice(0, endIndex),
            ];
        }
        return state;
    },
}, initialState);

export default reducer;
